import { merge } from 'lodash-es';

import {
	type ChapterTypes,
	type PageTypes,
	type ElementsTypes,
	type ColorPalettesType,
	type MetadataCatalog
} from '@editor2/types/config';
import { type DefaultConfig } from '@editor2/types/courseState';

interface Config {
	chapters: ChapterTypes;
	pages: PageTypes;
	elements: ElementsTypes;
	color_palettes?: ColorPalettesType;
	metadata?: MetadataCatalog;
}

export const filterAvailableTypes = (config: Config, defaults: DefaultConfig) => {
	const {
		chapters: chapterConfig,
		pages: pageConfig,
		elements: elementConfig,
		color_palettes,
		metadata
	} = config;
	const {
		chapters: defaultChapterConfig,
		pages: defaultPageConfig,
		elements: defaultElementsConfig
	} = defaults.bookConfig;

	const mergedChapterConfig = merge(defaultChapterConfig, chapterConfig);
	const mergedPageConfig = merge(defaultPageConfig, pageConfig);
	const mergedElementConfig = merge(defaultElementsConfig, elementConfig);

	const chapter_types: ChapterTypes = Object.entries(mergedChapterConfig.types).reduce(
		(acc, curr) => {
			const [key, value]: any = curr;
			return {
				...acc,
				[key]: {
					human_name: value.human_name,
					enabled: value.enabled,
					page_groups_enabled: value.settings.page_groups_enabled
				}
			};
		},
		{}
	);

	const page_types: PageTypes = Object.entries(mergedPageConfig.types).reduce((acc, curr) => {
		const [key, value]: any = curr;
		return {
			...acc,
			[key]: {
				human_name: value.human_name,
				enabled: value.enabled,
				elements: value.elements
			}
		};
	}, {});

	return {
		chapter_types,
		page_types,
		element_types: mergedElementConfig,
		color_palettes,
		metadata
	};
};

export const checkTypeIsSet = (config: PageTypes | ChapterTypes, type: string) => {
	return config[type] && config[type].enabled;
};
